import { Link } from "react-router-dom";

const repairServices = [
  { icon: "ri-smartphone-line", title: "Écran", desc: "Remplacement d'écran cassé, fissuré ou tactile défectueux sur smartphone et tablette." },
  { icon: "ri-battery-line", title: "Batterie", desc: "Remplacement de batterie usée qui ne tient plus la charge ou gonflée." },
  { icon: "ri-plug-line", title: "Connecteur de charge", desc: "Réparation du port de charge qui ne fonctionne plus ou ne tient pas le câble." },
  { icon: "ri-mic-line", title: "Micro / Haut-parleur", desc: "Dépannage audio : micro inaudible, haut-parleur grésillant ou silencieux." },
  { icon: "ri-camera-line", title: "Caméra", desc: "Remplacement de caméra avant ou arrière floue, cassée ou ne s'ouvrant plus." },
  { icon: "ri-refresh-line", title: "Mise à jour logiciel", desc: "Mise à jour système, réinstallation propre, optimisation et déblocage." },
  { icon: "ri-drop-line", title: "Désoxydation", desc: "Nettoyage et désoxydation après contact avec l'eau pour sauver votre appareil." },
  { icon: "ri-tablet-line", title: "Tablette", desc: "Réparation complète de tablettes toutes marques : écran, batterie, connectique." },
  { icon: "ri-gamepad-line", title: "Console de jeux", desc: "Réparation de consoles portables et manettes : joystick, batterie, écran." },
];

export default function Reparation() {
  return (
    <div className="animate-fade-in">
      {/* Hero Section */}
      <section className="relative bg-oya-black pt-28 pb-16 md:pt-36 md:pb-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-oya-red/10 via-transparent to-transparent" />
        <div className="max-w-7xl mx-auto relative">
          <div className="inline-block px-4 py-1.5 bg-oya-red/20 rounded-full mb-6">
            <span className="text-oya-red-light text-sm font-medium">/ RÉPARATION</span>
          </div>
          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-white max-w-3xl leading-tight">
            Réparation mobile
          </h1>
          <p className="mt-6 text-white/70 text-base md:text-lg max-w-xl leading-relaxed">
            Chaque réparation dépend du modèle, de la panne et de la disponibilité des pièces. Contactez OYA PHONE pour un devis personnalisé.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 md:py-24 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-oya-black">Les réparations proposées</h2>
            <p className="mt-4 text-oya-gray-medium max-w-lg">
              Uniquement sur rendez-vous. Interventions soignées avec pièces de qualité.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {repairServices.map((service) => (
              <div
                key={service.title}
                className="group p-6 md:p-8 rounded-xl bg-oya-cream hover:bg-oya-black transition-all duration-300 cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-oya-red/10 group-hover:bg-oya-red/20 transition-colors mb-5">
                  <i className={`${service.icon} text-oya-red text-xl`} />
                </div>
                <h3 className="text-lg font-bold text-oya-black group-hover:text-white transition-colors mb-2">
                  {service.title}
                </h3>
                <p className="text-sm text-oya-gray-medium group-hover:text-white/70 transition-colors leading-relaxed">
                  {service.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-24 px-4 bg-oya-cream">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-oya-black mb-4">
            Besoin d'une réparation ?
          </h2>
          <p className="text-oya-gray-medium mb-8">
            Contactez OYA PHONE pour un diagnostic et un devis personnalisé.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:0651004790"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-oya-red text-white font-medium rounded-full hover:bg-oya-red-dark transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              Appeler OYA PHONE
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-oya-black text-oya-black font-medium rounded-full hover:bg-oya-black hover:text-white transition-colors whitespace-nowrap"
            >
              <i className="ri-calendar-line" />
              Prendre rendez-vous
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}